/*
 * (c) Copyright, 2008-2015 Massachusetts Institute of Technology.
 *
 *     This material may be reproduced by or for the
 *     U.S. Government pursuant to the copyright license
 *     under the clause at DFARS 252.227-7013 (June, 1995).
 */
define(['hvx/modules/CoreModule', 'ol', './MapStyle', './FilteredCollection'],

	(Core, ol, StyleMap, FilteredCollection) => {

  let drawingLayer;
  let styleMap;

  const MapController = function(view, style, options){
    this.view = view;
      // TODO MEDIATOR:
	    // this.mediator = Core.Mediator.getInstance();

	    this.interactions = null;//current control
     this.activeLayers = [];
	    styleMap = style;

	    this.currentSourceAdd = this.currentSourceAdd.bind(this);
	    this.currentSourceRemove = this.currentSourceRemove.bind(this);

	    drawingSource = new ol.source.Vector({
      wrapX: false
    });
	    drawingLayer = new ol.layer.Vector({
		  source: new ol.source.Vector(),
		  style: this.getStyle
    });

    this.view.map.addLayer(drawingLayer);

    select = new ol.interaction.Select({
      style: false,//don't let select interaction alter style
      wrapX: false,
			//don't consider unmanaged layers or unselectable layers for selection
      filter: function(feature, layer) {
        if (!layer || layer.get('selectable') === false) {
          return false;
        } else {
          return !!layer;
        }
      }
    });
    
    select.on('select', (e) => {
      e.selected.forEach((feature) => {
        feature.set('style', feature.getStyle(), true);
        feature.setStyle(this.getSelectStyle);
      });
      e.deselected.forEach((feature) => {
        feature.setStyle(feature.get('style'));
        feature.unset('style', true);
      });
    });

    move = new ol.interaction.Translate({
      features: this.getEditableSelection()
    });

    this.setSource(drawingLayer.getSource()); //current drawing source

    this.drawingColor = '#000000';

    this.view.map.on('click', (e) => {
  		  Core.EventManager.fireEvent('map-view-click', e);
		  });
    this.view.map.on('rendercomplete', (e) => Core.EventManager.fireEvent('map-render-complete', e));
		
  };

  MapController.prototype.bindEvents = function(){
		//on selection add/remove, fire change events
    const selectedCollection = select.getFeatures();
    selectedCollection.on(['add', 'remove'], Ext.Function.createBuffered(() => {
      Core.EventManager.fireEvent('map-selection-change', selectedCollection.getArray().slice());
    }, 0));

    drawingSource.on('addfeature', this.drawingSourceAdd.bind(this));
    drawingSource.on('removefeature', this.drawingSourceRemove.bind(this));
  };

  MapController.prototype.setBaseLayer = function(layer){
    this.view.map.getLayers().setAt(0, layer);

    Core.EventManager.fireEvent('map-layer-setbase', layer);
  };

  MapController.prototype.zoomToExtent = function(extent){
    this.view.map.getView().fit(extent,this.view.map.getSize());
  };

  MapController.prototype.zoomTo = function(zoom){
    this.view.map.getView().setZoom(zoom); // TODO:need to test for max/min zoom level for current map first
  };

  MapController.prototype.getZoom = function(){
    return this.view.map.getView().getZoom();
  };

  MapController.prototype.orderLayers = function(metaData, zIndex) {
    // Redraw active layers in desired order
    // Get the layer full name
    try {
      for (let i=0; i<this.activeLayers.length; i++) {
        if (this.activeLayers[i].fullLayerName === metaData.fullLayerName) {
          this.activeLayers[i].layer.setZIndex(zIndex);
        }
      } 
    } catch (error) {
      // pass
    }

  };

	/**
	 * We have to listen to feature removal on all layers
	 * because the Select interaction doesn't handle removed
	 * features.
	 */
  const onRemoveFeature = function(evt){
    select.getFeatures().remove(evt.feature);
  };

  MapController.prototype.addLayer = function(layer, metaData){
    if (layer) {
      this.view.map.addLayer(layer);

      layer.getSource().on('removefeature', onRemoveFeature);
			/* Human readable metadata will look like this:
			{
				name:'displayname',
				layername: 'unique layer name'
				type: 'conditions/storm/surge/etc'
				orderingClass: 'A' 'B' 'C' -> To be defined
			}
			*/
      if (metaData) {
        metaData.layer = layer;
        this.activeLayers.push(metaData);
        setTimeout(() => {
          Core.EventManager.fireEvent('quickLayers.add', metaData, true);
        }, 100);
      }
      Core.EventManager.fireEvent('map-layer-add', layer);
    }
  };

  MapController.prototype.setLayerOpacity = function(layerName, opacity, thumb) {
    for (let i=0; i<this.activeLayers.length; i++) {
      if (this.activeLayers[i].fullLayerName === layerName) {
        const layer = this.activeLayers[i].layer;
        if (layer.get('title') === 'evaczone') {
          // For evaczone layer, update the fill opacity via ENV parameter
          const source = layer.getSource();
          if (source instanceof ol.source.TileWMS) {
            const params = source.getParams();
            // Get current stroke opacity or default to 1.0
            const currentParams = params.ENV ? params.ENV.split(';').reduce((acc, param) => {
              const [key, value] = param.split(':');
              acc[key] = value;
              return acc;
            }, {}) : {};
            // Update opacity 
            const fillOpacity = thumb ? 
              (thumb.index === 0 ? opacity/100 : currentParams.FILL_OPACITY) : 
              currentParams.FILL_OPACITY;
            const strokeOpacity = thumb ? 
              (thumb.index === 1 ? opacity/100 : currentParams.STROKE_OPACITY) : 
              currentParams.STROKE_OPACITY;
            params.ENV = `FILL_OPACITY:${fillOpacity};STROKE_OPACITY:${strokeOpacity}`;
            source.updateParams(params);
          }
        } else {
          // For all other layers, set overall opacity
          layer.setOpacity(opacity/100);
        }
      }
    } 
  };

  MapController.prototype.removeLayer = function(layer, layerName, removeAll, skipQLUpdate) {
		// null guard
    if (layer) {

      this.view.map.removeLayer(layer);

      const src = layer.getSource();
      if (src) {
				//stop listening on this layer source
        src.un('removefeature', onRemoveFeature);
				//remove any selected layer features
        if (src.getFeatures) {
          src.getFeatures().forEach(
						ol.Collection.prototype.remove, select.getFeatures());
        }
				// Remove value from our cache of active layers
        for (let i=0; i<this.activeLayers.length; i++) {
          if (this.activeLayers[i].fullLayerName === layerName && !skipQLUpdate) {
            const tData = this.activeLayers[i];
            this.activeLayers.splice(i,1);
            this.removeLayer(tData.layer, layerName);
            // remove the layer from quick layers if it exists
            if (layerName !== 'labels_layer') {
              Core.EventManager.fireEvent('quickLayers.remove', layerName);
            }
          } else if (this.activeLayers[i].layer === layer) {
            // Only match on the layer
            const tData = this.activeLayers[i];
            this.activeLayers.splice(i,1);
            this.removeLayer(tData.layer, layerName, removeAll, skipQLUpdate);
          }
        }
      }
      Core.EventManager.fireEvent('map-layer-remove', layer);
    }
  };

  MapController.prototype.getSelectStyle = function(feature, resolution){
    return styleMap.getStyle(feature, resolution, true);
  };

  MapController.prototype.getStyle = function(feature, resolution){
    return styleMap.getStyle(feature, resolution);
  };

  MapController.prototype.getDefaultInteractions = function(){
    return [select, move];
  };

  MapController.prototype.getSelectInteraction = function(){
    return select;
  };

  MapController.prototype.getSelection = function(){
    return select.getFeatures();
  };

  MapController.prototype.getEditableSelection = function(){
    return new FilteredCollection(select.getFeatures(), (feature) => {
			//ensure the feature is on the active source
      if (feature.getId() !== undefined) {
        return drawingSource.getFeatureById(feature.getId()) !== null;
      }
      return drawingSource.getFeatures().indexOf(feature) >= 0;
    });
  };

  MapController.prototype.getInteractions = function(){
    return this.view.map.getInteractions().getArray().slice();
  };

  MapController.prototype.setInteractions = function(interactions){
    this.interactions = setInteractions(this.view.map, interactions, this.interactions);
    Core.EventManager.fireEvent('hvx.map.interactions.change', interactions);
  };

	/** Source for Drawing Layer **/
  MapController.prototype.getSource = function(){
    return drawingSource;
  };

	/** Source for retrieving layer meta data */
  MapController.prototype.getActiveLayers = function() {
    return this.activeLayers;
  },

	/** Source for Drawing Layer **/
	MapController.prototype.setSource = function(source){
  const oldSource = this.currentDrawingSource;
  if(oldSource){
    this.unbindSourceEvents(oldSource);
    this.currentDrawingSource = null;
  }

  drawingSource.clear();
  select.getFeatures().clear();

  if(source){
    drawingSource.addFeatures(source.getFeatures());

    this.currentDrawingSource = source;
    this.bindSourceEvents(source, select);
  }

  Core.EventManager.fireEvent('map-source-set', oldSource, source);
};

  MapController.prototype.setDrawingColor = function(color){
    this.drawingColor = color;

    Core.EventManager.fireEvent('map-color-change', color);
  };

  MapController.prototype.getDrawingColor = function(){
    return this.drawingColor;
  };

  MapController.prototype.getDetailOverlay = function(){
    return this.view.popupOverlay;
  };

  MapController.prototype.bindSourceEvents = function(source){
    source.on('addfeature', this.currentSourceAdd);
    source.on('removefeature', this.currentSourceRemove);
  };

  MapController.prototype.unbindSourceEvents = function(source){
    source.un('addfeature', this.currentSourceAdd);
    source.un('removefeature', this.currentSourceRemove);
  };

  var setInteractions = function(map, newActions, oldActions){
    if(oldActions){
      oldActions.forEach(map.removeInteraction, map);
    }
    if(newActions){
      newActions.forEach(map.addInteraction, map);
    }
    return newActions;
  };

  MapController.prototype.drawingSourceAdd = function(evt) {
    const feature = evt.feature;
    if (this.currentDrawingSource && !feature.mapControllerSyncing) {
      feature.mapControllerSyncing = true;
      this.currentDrawingSource.addFeature(feature);
      delete feature.mapControllerSyncing;
    }
  };

  MapController.prototype.currentSourceAdd = function(evt) {
    const feature = evt.feature;
    if (!feature.mapControllerSyncing) {
      feature.mapControllerSyncing = true;
      drawingSource.addFeature(feature);
      delete feature.mapControllerSyncing;
    }
  };

  MapController.prototype.drawingSourceRemove = function(evt) {
    const feature = evt.feature;

		//the select interaction does not detect removed features, they stay selected
		//https://github.com/openlayers/ol3/issues/2485
    select.getFeatures().remove(feature);

    if (this.currentDrawingSource && !feature.mapControllerSyncing) {
      feature.mapControllerSyncing = true;
      this.currentDrawingSource.removeFeature(feature);
      delete feature.mapControllerSyncing;
    }
  };

  MapController.prototype.currentSourceRemove = function(evt) {
    const feature = evt.feature;
    if (!feature.mapControllerSyncing) {
      feature.mapControllerSyncing = true;
      drawingSource.removeFeature(feature);
      delete feature.mapControllerSyncing;
    }
  };

  MapController.prototype.getMap = function(){
    return this.view.map;
  };

  return MapController;
});
